<template>
  <article class="message is-warning">
    <div class="message-header">
      <p>
        {{
          $texts(
            'premiumMembershipRequired',
            'Premiummidgliedschaft erforderlich',
          )
        }}
      </p>
    </div>
    <div class="message-body">
      <p
        class="mb-4"
        v-html="
          $texts(
            'premiumHint',
            'Um das Angebot nutzen zu können, müssen Sie den Mitgliedsstatus <strong>Premium-Mitglied</strong> haben. Sie können Ihre Mitgliedschaft in Ihrem Benutzerkonto aufwerten.',
          )
        "
      />
      <nuxt-link
        :to="upgradeDestination"
        class="button is-normal is-fullwidth mb-2"
        >{{
          $texts('becomePremiumMember', 'Premium-Mitglied werden')
        }}</nuxt-link
      >
    </div>
  </article>
</template>

<script setup lang="ts">
const user = useDrupalUser()
const { $texts } = useNuxtApp()

const upgradeDestination = computed(() => {
  if (user.value.loggedIn) {
    return '/user/' + user.value.uid
  }
  return '/user'
})
</script>
